// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__31tCS","footer":"ModalFilter_footer__xzBsn"};